import React from 'react'

const CustomDot = ({
  cx,
  cy,
  payload,
  highlightedYear,
  lineKey,
  onDotHover,
  onDotLeave,
  onYearClick,
  onDotClick,
  restrictHighlightToSelectedLine = false,
  isLineSelected = false
}) => {
  if (!cx || !cy || isNaN(cx) || isNaN(cy)) return null

  const payloadYear = payload && payload.year
  if (!payloadYear) return null

  const isYearHighlighted =
    highlightedYear &&
    parseInt(highlightedYear, 10) === parseInt(payloadYear, 10)
  const isHighlighted = isYearHighlighted && (!restrictHighlightToSelectedLine || isLineSelected)

  return (
    <circle
      cx={cx}
      cy={cy}
      r={isHighlighted ? 6 : 3}
      fill={isHighlighted ? '#FB923C' : '#648E62'}
      stroke='#fff'
      strokeWidth={2}
      style={{ cursor: 'pointer' }}
      onClick={(e) => {
        e.stopPropagation()
        if (onYearClick && payload && payload.year != null) {
          onYearClick(payload.year)
        }
        if (onDotClick) {
          onDotClick(payload, lineKey)
        }
      }}
      onMouseEnter={() => {
        if (onDotHover) onDotHover(payload, lineKey, { cx, cy })
      }}
      onMouseLeave={(e) => {
        if (onDotLeave) onDotLeave(e)
      }}
    />
  )
}

export default CustomDot
